import React from 'react';

import colors from 'Theme/lightTheme/colors';

import { StyledListItem, List, Icon, IconWrapper } from './IconList.styled';

interface ListItem {
    id: string;
    icon: React.ElementType;
    iconColour?: string;
    children?: string | React.ReactNode;
}

export interface Props {
    list: ListItem[];
}

const IconList: React.FC<Props> = ({ list }) => {
    return (
        <List>
            {list.map(item => (
                <StyledListItem key={item.id}>
                    <IconWrapper>
                        <Icon
                            as={item.icon}
                            $iconColour={
                                item.iconColour ? item.iconColour : colors.primaryContrast.hex
                            }
                        />
                    </IconWrapper>
                    {typeof item.children === 'string' ? (
                        <p>{item.children}</p>
                    ) : (
                        <div>{item.children}</div>
                    )}
                </StyledListItem>
            ))}
        </List>
    );
};

export default IconList;
